"use client";

import { Suspense, useState } from "react";
import { signIn } from "next-auth/react";
import { useRouter, useSearchParams } from "next/navigation";
import { Logo } from "@/components/Logo";

export default function LoginPage() {
  return (
    <Suspense fallback={null}>
      <LoginInner />
    </Suspense>
  );
}

function LoginInner() {
  const router = useRouter();
  const params = useSearchParams();
  const errParam = params?.get("err");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    const res = await signIn("credentials", { email, password, redirect: false });
    setLoading(false);
    if (res?.error) {
      setErr("E-mail ou senha incorretos.");
      return;
    }
    router.push("/");
    router.refresh();
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-neutral-50 via-white to-neutral-50 relative overflow-hidden">
      {/* sutil ornamento de fundo */}
      <div className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-brand-100/50 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full bg-brand-100/40 blur-3xl pointer-events-none" />

      <div className="relative w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <div className="rounded-2xl bg-white border border-neutral-200 shadow-sm p-7">
          <div className="mb-6">
            <h1 className="text-xl font-semibold text-neutral-900 tracking-tight">Bem-vindo de volta</h1>
            <p className="text-sm text-neutral-500 mt-1">Acesse seus relatórios e configurações.</p>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-neutral-700 mb-1.5">E-mail</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3.5 py-2.5 rounded-lg border border-neutral-300 focus:border-brand-500 focus:ring-4 focus:ring-brand-500/10 focus:outline-none text-sm transition-shadow"
                autoComplete="email"
                placeholder="voce@empresa.com.br"
              />
            </div>
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label className="block text-xs font-medium text-neutral-700">Senha</label>
                <a
                  href="/forgot-password"
                  className="text-[11px] text-brand-600 hover:text-brand-700 hover:underline"
                >
                  Esqueceu?
                </a>
              </div>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3.5 py-2.5 rounded-lg border border-neutral-300 focus:border-brand-500 focus:ring-4 focus:ring-brand-500/10 focus:outline-none text-sm transition-shadow"
                autoComplete="current-password"
                placeholder="••••••••"
              />
            </div>

            {(err || errParam) && (
              <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2.5">
                {err ??
                  (errParam === "no-account"
                    ? "Sua conta ainda não foi vinculada a uma empresa. Peça ao admin para adicionar você."
                    : "Ocorreu um erro.")}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 rounded-lg bg-neutral-900 hover:bg-neutral-800 text-white text-sm font-medium disabled:opacity-50 transition-colors shadow-sm"
            >
              {loading ? "Entrando…" : "Entrar"}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-neutral-400 mt-6">
          Problemas pra acessar? Fale com o time NexTags.
        </p>
      </div>
    </div>
  );
}
